import React, { useEffect, useRef, useState } from "react";
import { Button, Overlay, OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { Placement } from "react-bootstrap/esm/Overlay";

export interface ITooltipProps {
    index: string;
    tip: string;
    placement?: Placement;
}

//function InfoBubble({ index, tip }: ITooltipProps) {
//    const bubble = <Popover id="popover-basic" rootClose={ true}
//>
//        <Popover.Title as="h3">Info</Popover.Title>
//        <Popover.Content>
//            { tip}
//        </Popover.Content>
//    </Popover>;

//    return <OverlayTrigger trigger="click" placement="right" overlay={bubble}>
//        <i className="fa fa-question"></i>
//    </OverlayTrigger>
//}

function InfoBubble({ index, tip, placement }: ITooltipProps) {
    const [show, setShow] = useState(false);
    const target = useRef(null);

    return (
        <>
            <a className="fa fa-info-circle" ref={target} onClick={() => setShow(!show)}>
            </a>
            <Overlay target={target.current} show={show} placement={ placement || 'auto'} rootClose={true} onHide={() => setShow(!show)}>
                {(props) => (
                    <Tooltip id="tooltip" className="" {...props}>
                        <p dangerouslySetInnerHTML={{ __html:tip }}></p>
                    </Tooltip>
                )}
            </Overlay>
        </>
    );
}


export default InfoBubble;